import { H1 } from '~/src/common/components/Typography';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag';

import * as S from './layout';

const HomeScreenHeader = ({ title }: { title: string }) => {
  const isFamiliesVisibleOnMobile = useFeatureFlag('show-families-home-mobile');

  if (isFamiliesVisibleOnMobile) return null;

  return (
    <S.HomeTitleContainer>
      <S.Waves />
      <H1>{title}</H1>
    </S.HomeTitleContainer>
  );
};

export default HomeScreenHeader;
